<template>
  <div id="page-day-detail">
    <el-form
      class="search-form"
      ref="searchForm"
      :inline="true"
      :model="searchForm"
      label-width="8em"
    >
      <el-row>
        <el-form-item prop="businessLine" label="业务线" required>
          <filter-business-line
            :value.sync="searchForm.businessLine"
            :ops="false"
            required
            @change="handleBusinessLineChange"
          />
        </el-form-item>
        <el-form-item prop="regionId" label="Region">
          <filter-businessline-region
            :value.sync="searchForm.regionId"
            :businessLine="searchForm.businessLine"
          />
        </el-form-item>
        <el-form-item prop="workType" label="岗位类型">
          <filter-worker-type :value.sync="searchForm.workType" />
        </el-form-item>
        <el-form-item prop="unit" label="结算方式">
          <filter-charge-type
            :value.sync="searchForm.unit"
            :businessLine="searchForm.businessLine"
          />
        </el-form-item>
        <el-form-item prop="name" label="姓名">
          <el-input
            v-model.trim="searchForm.userName"
            :maxlength="32"
            clearable
            placeholder="姓名"
          />
        </el-form-item>
        <el-form-item prop="phone" label="手机号">
          <el-input
            v-model.trim="searchForm.phone"
            :maxlength="11"
            clearable
            placeholder="非必填"
          />
        </el-form-item>
        <el-form-item prop="supplierId" label="合作商">
          <filter-businessline-partner
            :value.sync="searchForm.supplierId"
            :businessLine="searchForm.businessLine"
          />
        </el-form-item>
        <template v-if="!isSpockType">
          <el-form-item prop="settlementAction" label="动作">
            <el-select
              filterable
              clearable
              v-model="searchForm.settlementAction"
              placeholder="动作"
            >
              <el-option
                v-for="item in actionTypeList"
                :label="item.actionName"
                :value="item.actionType"
                :key="item.actionType"
              />
            </el-select>
          </el-form-item>

          <el-form-item prop="jobPositionId" label="业务类型">
            <el-select
              filterable
              clearable
              v-model="searchForm.jobPositionId"
              placeholder="业务类型"
            >
              <el-option
                v-for="item in workTaskTypeList"
                :label="item.text"
                :value="item.text"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
        </template>
        <el-form-item prop="workType" label="工种" v-if="isSpockType">
          <filter-job-type :value.sync="searchForm.jobPositionId" />
        </el-form-item>
        <el-form-item label="时间段" required>
          <filter-date-range
            :value.sync="dateRange"
            :init-range="1"
            required
            @update:value="handleDateChange"
          />
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button type="primary" @click="getDataList(true)" :loading="isLoading">查询</el-button>
        </el-form-item>
        <el-form-item prop="accountPeriod" label="账期">
          <el-date-picker
            v-model="searchForm.accountPeriod"
            type="month"
            placeholder="账期"
            value-format="yyyy-MM"
            @change="changeAccountMonth"
          />
        </el-form-item>
      </el-row>
    </el-form>
    <el-row class="align-r margin-b-10">
      <el-button @click="getDataList(true, true)" :loading="isDownLoading">下载列表</el-button>
    </el-row>

    <el-tabs v-model="searchForm.isCross" @tab-click="getDataList(true)">
      <el-tab-pane label="计费薪资" name="0" key="count">
        <el-table stripe v-loading="isLoading" :data="dataList">
          <el-table-column
            v-for="item in columnList"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :render-header="customFieldColumn"
            min-width="140"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'timePeriodCode'">
                <el-button @click="handleShowDetail(scope.row, 'time')" type="text">{{
                  scope.row[item.prop]
                }}</el-button>
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="dataList.length">
            <template slot-scope="scope">
              <el-button type="text" @click="handleShowDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="转结薪资" name="1" key="cross">
        <el-table stripe v-loading="isLoading" :data="dataList">
          <el-table-column
            v-for="item in columnList"
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :render-header="customFieldColumn"
            min-width="140"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'timePeriodCode'">
                <el-button @click="handleShowDetail(scope.row, 'time')" type="text">{{
                  scope.row[item.prop]
                }}</el-button>
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="dataList.length">
            <template slot-scope="scope">
              <el-button type="text" @click="handleShowDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <div class="paging-wrapper" v-if="totalPages > 1">
      <el-pagination
        background
        @current-change="handlePageNoChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        layout="prev, pager, next, slot, jumper"
        :total="totalAmount"
      >
        <span class="page-indicator"
          ><em>{{ pageNo }}</em
          >/{{ totalPages }}</span
        >
      </el-pagination>
    </div>
    <el-dialog
      :title="firstType === 'time' ? '包时结费时段详情' : '详情'"
      :visible.sync="costDiaglogVisible"
      width="80%"
    >
      <!-- 基础数据 -->
      <div class="person-detail ui-mt-20" v-if="!isFirstDialogSpock">
        <el-row gutter="4">
          <el-col :span="4">
            <span>日期：</span>
            <span>{{ personDetailObj.day || '-' }}</span>
          </el-col>
          <el-col :span="4" :offset="1">
            <span>Region：</span>
            <span>{{ personDetailObj.regionName || '-' }}</span>
          </el-col>
          <el-col :span="4" :offset="1">
            <span>姓名：</span>
            <span>{{ personDetailObj.userName || '-' }}</span>
          </el-col>
          <el-col :span="4" :offset="1">
            <span class="text">所属供应商：</span>
            <span class="text2">{{ personDetailObj.supplierName || '-' }}</span>
          </el-col>
        </el-row>

        <el-row class="ui-mt-20">
          <el-col :span="4">
            <span>手机号：</span>
            <span>{{ personDetailObj.phoneNo || '-' }}</span>
          </el-col>
          <el-col :span="4" :offset="1">
            <span>载具：</span>
            <span>{{ personDetailObj.carrier || '-' }}</span>
          </el-col>
          <el-col :span="4" :offset="1">
            <span>计薪方案名称：</span>
            <span>{{ pricePlanName || '-' }}</span>
          </el-col>
          <el-col :span="4" :offset="1">
            <span>结费方式：</span>
            <span>{{ personDetailObj.unitDesc || '-' }}</span>
          </el-col>
        </el-row>
      </div>

      <div class="person-detail ui-mt-20" v-else>
        <el-row gutter="4">
          <el-col :span="4">
            <span>日期：</span>
            <span>{{ personDetailObj.day || '-' }}</span>
          </el-col>
          <el-col :span="4" :offset="2">
            <span>Region：</span>
            <span>{{ personDetailObj.regionName || '-' }}</span>
          </el-col>
          <el-col :span="4" :offset="2">
            <span>姓名：</span>
            <span>{{ personDetailObj.userName || '-' }}</span>
          </el-col>
        </el-row>

        <el-row class="ui-mt-20">
          <el-col :span="4">
            <span class="text">所属供应商：</span>
            <span class="text2">{{ personDetailObj.supplierName || '-' }}</span>
          </el-col>
          <el-col :span="4" :offset="2">
            <span>手机号：</span>
            <span>{{ personDetailObj.phoneNo || '-' }}</span>
          </el-col>
          <el-col :span="4" :offset="2">
            <span>载具：</span>
            <span>{{ personDetailObj.carrier || '-' }}</span>
          </el-col>
        </el-row>
      </div>
      <el-table :data="detailList" class="margin-t-20" :span-method="arraySpanMethod">
        <el-table-column
          v-for="item in detailColumnList"
          :prop="item.prop"
          :label="item.label"
          :key="item.prop"
          min-width="140"
        >
          <template slot-scope="scope">
            <div v-if="item.prop === 'number'">
              <el-button @click="showOrderDetail(scope, 'valid')" type="text">{{
                scope.row[item.prop]
              }}</el-button>
            </div>
            <div v-else-if="item.prop === 'noBillingNumber'">
              <el-button @click="showOrderDetail(scope, 'invalid')" type="text">{{
                scope.row[item.prop]
              }}</el-button>
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
      </el-table>

      <common-pagination
        v-show="firstTotal && isByTime"
        :total="firstTotal"
        :page.sync="firstQuery.page"
        :limit.sync="firstQuery.limit"
        @pagination="getPersonWorkDetail(personDetailObj, firstType)"
      />
    </el-dialog>

    <el-dialog title="计费详情" :visible.sync="orderDiaglogVisible" width="80%">
      <el-table :data="workerDetailList" class="ui-mt-30">
        <el-table-column
          v-for="item in workerColumnList"
          :prop="item.prop"
          :label="item.label"
          :key="item.prop"
          :render-header="customFieldColumnDetail"
          min-width="160"
        >
          <template slot-scope="scope">
            <div v-if="checkShowTip(scope.row, item.prop)">
              <el-tooltip effect="light" :content="scope.row['reason']" placement="top-start">
                <span>{{ scope.row[item.prop] }}</span>
              </el-tooltip>
            </div>
            <div v-else-if="item.prop === 'incrementPrice'">
              <div v-for="(price, index) in handleAddMoney(scope.row[item.prop])" :key="index">
                {{ price }}
              </div>
            </div>
            <div v-else-if="item.prop === 'metricsEncourage'">
              <div v-for="(ratio, index) in handleAddMoney(scope.row[item.prop])" :key="index">
                {{ ratio }}
              </div>
            </div>
            <div v-else-if="item.prop === 'reason'">
              <div v-for="(reason, index) in handleAddMoney(scope.row[item.prop])" :key="index">
                {{ reason }}
              </div>
            </div>
            <div v-else-if="showMoneyTip(scope.row, item.prop)">
              <el-tooltip effect="light" placement="top-start">
                <div slot="content">
                  <div
                    v-for="(item, index) in handlePriceDetail(scope.row['priceDetails'])"
                    :key="index"
                  >
                    <span>{{ `${item.label}：${item.value}` }}</span>
                  </div>
                </div>
                <span>{{ scope.row[item.prop] }}</span>
              </el-tooltip>
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging-wrapper" v-if="totalPages2 > 1">
        <el-pagination
          @current-change="handlePageNoChange2"
          :current-page.sync="pageNo2"
          :page-size="pageSize2"
          layout="prev, pager, next, slot, jumper"
          :total="totalAmount2"
        >
          <span class="page-indicator"
            ><em>{{ pageNo2 }}</em
            >/{{ totalPages2 }}</span
          >
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="orderDiaglogVisible = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination'
import pagination2 from '@/mixins/pagination2'
import bikePersonData from '@/mixins/bikePersonData'
import commonPagination from '@/components/common/CommonPagination.vue'
import { dateFormat, rangeDay } from '@/utils'

const Ratio = '按系数定价'
export default {
  mixins: [pagination, pagination2, bikePersonData],
  components: { commonPagination },
  data() {
    return {
      isLoading: false,
      dataList: [],
      dateRange: [],
      columnList: [],
      detailColumnList: [],
      detailList: [],
      workerDetailList: [],
      workerColumnList: [],
      searchForm: {
        phone: '',
        regionId: '',
        supplierId: '',
        businessLine: '',
        workType: '',
        settlementAction: '',
        jobPositionId: '',
        userName: '',
        unit: '',
        st: '',
        ed: '',
        accountPeriod: '',
        isCross: '0',
      },
      orderDiaglogVisible: false,
      isDownLoading: false,
      firstType: '',
      firstTotal: 0,
      firstQuery: {
        page: 1,
        limit: 20,
      },
      pageSize: 20,
      totalAmount: 0,
      costDiaglogVisible: false,
      personDetailObj: {},
      countType: '',
    }
  },

  created() {
    this.initPagination('getDataList', false)
    this.initPagination2('queryCostDetail', false)
  },

  methods: {
    handleAddMoney(str) {
      if (!str) return []
      return str.split(';')
    },
    handleDateChange() {
      if (this.dateRange && this.dateRange.length) {
        this.searchForm.accountPeriod = ''
      }
    },
    changeAccountMonth(val) {
      if (val) {
        this.dateRange = []
      }
    },
    // 列表数据
    getDataList(init = false, exportData = false) {
      if (init && !exportData) this.pageNo = 1
      const params = {
        ...this.searchForm,
      }
      if (this.dateRange) {
        const dayNum = rangeDay(this.dateRange[0], this.dateRange[1]).length
        params.st = dateFormat(this.dateRange[0]) || ''
        params.ed = dateFormat(this.dateRange[1]) || ''
        if (dayNum > 31) {
          return this.$message.error('最多选择连续31天')
        }
      }

      if (Array.isArray(params.unit)) {
        params.unit = params.unit.join()
      }
      if (exportData) return this.exportItem(params)
      params.pageNumber = this.pageNo
      params.pageSize = this.pageSize
      this.isLoading = true
      this.fetch
        .get('dayGetStaffSettlementRecord', { params })
        .then(res => {
          setTimeout(() => {
            this.isLoading = false
          }, 200)
          const data = res.data || {}
          this.columnList = data.columnList || []
          this.dataList = data.contentList || []
          this.totalAmount = res.recordsTotal || 0
        })
        .catch(() => {
          this.dataList = []
          this.isLoading = false
        })
    },

    customFieldColumnDetail(h, { column, $inedx }) {
      const flag = this.workerDetailList.some(item => item.priceType === Ratio)
      const ratioTips =
        '金额=车型系数 * 商系数 * (调度距离 + 单次批量装车总量 + 单次批量卸车总量)*后验指标系数'
      const moneyTips = '金额=（基础单价+加价金额)*后验指标系数'
      const str = flag ? ratioTips : moneyTips
      if (column.property === 'price') {
        return h('span', [
          h('span', column.label + ' '),
          h(
            'el-tooltip',
            {
              props: {
                effect: 'dark',
                content: str,
                placement: 'top',
              },
            },
            [
              h('i', {
                class: 'el-icon-question',
              }),
            ]
          ),
        ])
      } else {
        return h('span', column.label + ' ')
      }
    },

    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (this.firstType !== 'time')
        return {
          rowspan: 1,
          colspan: 1,
        }
      const tmpList = ['timePeriod', 'timeLabel', 'reason']
      if (tmpList.includes(column.property)) {
        if (row.mergeLength) {
          return {
            rowspan: row.mergeLength || 1,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },

    customFieldColumn(h, { column, $index }) {
      if (column.property === 'timePeriodCode') {
        return h('span', [
          h('span', column.label + ' '),
          h(
            'el-tooltip',
            {
              props: {
                effect: 'dark',
                content: '点击时段量查看包时详细数据',
                placement: 'top',
              },
            },
            [
              h('i', {
                class: 'el-icon-question',
              }),
            ]
          ),
        ])
      } else {
        return h('span', column.label + ' ')
      }
    },

    handleBusinessLineChange() {
      this.dateRange = [new Date().getTime(), new Date().getTime()]
      this.searchForm.unit = ''
      this.searchForm.accountPeriod = ''
    },
    mergeTableDetailList() {
      if (!this.detailList.length) return []
      const resList = JSON.parse(JSON.stringify(this.detailList)) || []
      for (let i = 0; i < resList.length; ) {
        const tmpRow = resList[i].row
        const mergeLength = resList.filter(item => item.row === tmpRow).length || 0
        resList[i].mergeLength = mergeLength
        i = mergeLength + i
      }
      return resList
    },

    // 展示工种计费详情
    showOrderDetail(obj = {}, type) {
      // 总计不可点击
      if (obj.$index === this.detailList.length - 1) return
      this.pageNo2 = 1
      this.orderDiaglogVisible = true
      this.workTypeConfigObj = obj.row || {}
      this.countType = type
      this.queryCostDetail(obj.row, type)
    },

    // 打开详情
    showCostDetail(item = {}, type) {
      this.costDiaglogVisible = true
      this.queryCostDetail(item, type)
    },

    // 不计费 | 状态
    checkShowTip(rowObj = {}, name = '') {
      return name === 'statusing' && rowObj[name] === '不计费'
    },
    handlePriceDetail(detail = '') {
      const tmpDetail = (detail && JSON.parse(detail)) || {}
      const tmpList = []
      Object.keys(tmpDetail).forEach(key => {
        tmpList.push({
          label: key,
          value: tmpDetail[key],
        })
      })
      return tmpList
    },

    // 金额
    showMoneyTip(rowObj = {}, name = '') {
      return name === 'price' && rowObj.status === '已计费' && rowObj.priceDetails
    },

    // 获取工种计费详情
    queryCostDetail(item = {}, type) {
      this.isLoading = true
      const params = {
        userId: item.userId || this.workTypeConfigObj.userId,
        date: item.day || this.workTypeConfigObj.day,
        jobPosition: item.jobPosition || this.workTypeConfigObj.jobPosition,
        settlementAction: item.settlementAction || this.workTypeConfigObj.settlementAction,
        businessLine: this.personDetailObj.businessLine,
        timePeriodRealCode: item.timePeriodRealCode || this.workTypeConfigObj.timePeriodRealCode,
        unit: item.unit || this.workTypeConfigObj.unit,
        status: type === 'valid' ? 1 : this.countType === 'valid' ? 1 : 0,
        timeDetail: !!this.isByTime,
        isCross: this.searchForm.isCross,
        pageNumber: this.pageNo2,
        pageSize: this.pageSize2,
      }
      this.fetch
        .get('dayGetStaffRecordDetail', { params })
        .then(res => {
          this.isLoading = false
          const data = res.data.data || {}
          this.workerColumnList = data.columnList || []
          this.workerDetailList = data.contentList || []
          this.totalAmount2 = res.data.recordsTotal || 0
        })
        .catch(() => {
          this.isLoading = false
        })
    },

    // 详情
    handleShowDetail(rowObj = {}, type = '') {
      this.firstQuery.page = 1
      this.firstType = type
      this.costDiaglogVisible = true
      this.personDetailObj = rowObj
      this.getPersonWorkDetail(rowObj, type)
    },

    // 获取人员工作量详情
    getPersonWorkDetail(rowObj = {}, type) {
      const params = {
        isDetail: true,
        userId: rowObj.userId || '',
        day: rowObj.day,
        unit: rowObj.unit,
        businessLine: rowObj.businessLine,
        isCross: this.searchForm.isCross,
        pageSize: this.firstQuery.limit,
        pageNumber: this.firstQuery.page,
      }
      if (type === 'time') {
        delete params.isDetail
      }
      const api = type === 'time' ? 'getStaffSettlementRecordByTime' : 'dayGetStaffSettlementRecord'
      this.fetch
        .get(api, { params })
        .then(res => {
          this.isLoading = false
          const data = res.data || {}
          this.detailColumnList = data.columnList || []
          this.detailList = data.contentList || []
          this.firstTotal = res.recordsTotal || 0
          if (type === 'time') {
            this.detailList = this.mergeTableDetailList()
          }
        })
        .catch(() => {
          this.isLoading = false
        })
    },

    // 导出
    exportItem(params) {
      this.isDownLoading = true
      this.fetch
        .get('dayExportStaffRecord', {
          params,
        })
        .then(res => {
          this.isDownLoading = false
          if (res.data) {
            window.open(res.data)
          } else {
            this.$message.error('数据错误，请重试')
          }
        })
        .catch(() => {
          this.isDownLoading = false
        })
    },
  },

  computed: {
    isSpockType() {
      return this.searchForm.businessLine === 1203
    },
    isFirstDialogSpock() {
      return +this.personDetailObj.businessLine === 1203
    },
    isByTime() {
      return this.firstType === 'time'
    },
    pricePlanName() {
      return this.detailList && this.detailList[0] && this.detailList[0].payrollName
    },
  },
  watch: {
    isSpockType(val) {
      this.searchForm.settlementAction = ''
      this.searchForm.jobPositionId = ''
    },
  },
}
</script>
